import React, {useEffect, useRef, useState} from 'react'
import { Link, useLocation } from 'react-router-dom'

import logo from '../../../images/basic/footer/generium-logo-short2.svg'
//import logo2 from '../../../images/basic/footer/generium-logo-short.png'
import search from '../../../images/main/search.svg'

import styles from './styles.module.scss'

const Footer = ({ ourRef, setSearchMainInput, searchMainInput }) => {
  const { pathname } = useLocation()
  const ref = useRef(null)
  const [enter, setEnter] = useState('')

  useEffect(() => {
    if (enter === 'Enter') {
      document.getElementById('myBtn').click()
    }
  }, [enter])

  const openFormRef = () => {
    ourRef?.current.scrollIntoView()
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapper_content}>
        <div className={styles.wrapper_left}>
          <img
            className={styles.wrapper_content_img}
            src={logo}
            alt='logo-footer'
          />
          <div className={styles.wrapper_input_block}>
            <p>Карьера под вашим контролем</p>
            {
              pathname === '/listing' ? (
              <button onClick={openFormRef} className={styles.button}>
                Подать заявку <span>&rarr;</span>
              </button>
            ) : (
              <div className={styles.wrapper_input}>
                <input
                  onKeyDown={e => setEnter(e.key)}
                  value={searchMainInput}
                  onChange={e => setSearchMainInput(e.target.value)}
                  placeholder='Найти вакансию'
                />
                <Link to='/listing' id='myBtn'>
                  <img src={search} alt='search' />
                </Link>
              </div>
            )}
          </div>
        </div>

        <div className={styles.wrapper_right}>
          <img
            className={styles.wrapper_content_img}
            src={logo}
            alt='logo-footer'
          />
         </div>
      </div>
      <div className={styles.wrapper_copy}>
        <nav className={styles.wrapper_copy_down_nav}>
          <a href='https://generium.ru' target='_blank' className={styles.wrapper_copy_down_nav_link} id={styles["wrapper_copy_down_nav_link_site"]}>
            <span>О Generium</span>
          </a>
          <a href='https://vk.com/generium_career' target='_blank' className={styles.wrapper_copy_down_nav_link} id={styles["wrapper_copy_down_nav_link_vk"]}>
            <span>VK</span>
          </a>
          <a href='https://t.me/generium_career' target='_blank' className={styles.wrapper_copy_down_nav_link} id={styles["wrapper_copy_down_nav_link_telegram"]}>
            <span>Telegram</span>
          </a>
          <a href='https://www.linkedin.com/company/3606142/admin/page-posts/published/' target='_blank' className={styles.wrapper_copy_down_nav_link} id={styles["wrapper_copy_down_nav_link_linkedin"]}>
            <span>LinkedIn</span>
          </a>
          {/* <a href='https://www.youtube.com/@generiumpharmaceuticals8783' target='_blank' className={styles.wrapper_copy_down_nav_link} id={styles["wrapper_copy_down_nav_link_youtube"]}>
            <span>YouTube</span>
          </a> */}
        </nav>
        <div className={styles.wrapper_copy_nav}>
          <Link className={styles.wrapper_down_navLink} to='/privacy-policy' onClick={() => window.scrollTo(0, 0)}>
            Политика конфиденциальности
          </Link>
          <div className={styles.wrapper_copy_tech}>
            <a href='https://web.techart.ru' target='_blank' className={styles.wrapper_right_nav_link} rel='nofollow'>Сопровождение</a> сайта{' '}-{' '}
            <a href='https://techart.ru' target='_blank' className={styles.wrapper_right_nav_link} rel='nofollow'>
              Текарт
            </a>
          </div>
        </div>

      </div>

      <div className={styles.wrapper_bottom_text}><p>Персональные данные опубликованы на сайте при наличии правовых оснований в соответствии с ч.1 ст.6 и ст.10.1 152-ФЗ. Субъектами установлены запреты на обработку неограниченным кругом лиц опубликованных персональных данных</p></div>
    </div>
  )
}

export default Footer
